import { useEffect, useState } from "react";

// PATCH 35 M8 — discoverable keyboard shortcuts + a "?" cheat sheet, across both dashboards.
const SHORTCUTS = [
  ["⌘ / Ctrl + K", "Open search & command palette"],
  ["g then w", "Go to Workspace"],
  ["g then b", "Go to Billing"],
  ["g then m", "Go to Marketplace"],
  ["?", "Show this cheat sheet"],
  ["Esc", "Close any panel or dialog"],
];

export default function ShortcutHelp() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let g = false, t;
    const onKey = (e) => {
      const typing = /input|textarea|select/i.test(e.target?.tagName || "");
      if (typing) return;
      if (e.key === "?") { e.preventDefault(); setOpen((o) => !o); return; }
      if (e.key === "Escape") { setOpen(false); return; }
      if (e.key.toLowerCase() === "g") { g = true; clearTimeout(t); t = setTimeout(() => (g = false), 800); return; }
      if (g) {
        g = false;
        const map = { w: "/workspace", b: "/billing", m: "/marketplace" };
        if (map[e.key.toLowerCase()]) window.location.assign(map[e.key.toLowerCase()]);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(17,17,19,.6)", zIndex: 80, display: "flex", alignItems: "center", justifyContent: "center" }}
      data-testid="shortcut-help" onClick={() => setOpen(false)}>
      <div className="k-container k-fadein" onClick={(e) => e.stopPropagation()} style={{ width: 420, padding: 24 }}>
        <h3 className="k-heading" style={{ marginTop: 0, fontSize: 18 }}>Keyboard shortcuts</h3>
        {SHORTCUTS.map(([k, d]) => (
          <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid var(--border)" }}>
            <span className="k-muted" style={{ fontSize: 13 }}>{d}</span>
            <kbd className="k-badge" style={{ fontSize: 11 }}>{k}</kbd>
          </div>
        ))}
        <button className="k-btn k-btn-ghost" data-testid="shortcut-help-close" style={{ marginTop: 14 }} onClick={() => setOpen(false)}>Close</button>
      </div>
    </div>
  );
}
